import React, { useState } from 'react';
import { getApiEndpoint, setApiEndpoint, getApiUrl } from '../utils/api';
import './Settings.css';

function Settings() {
  const [currentEndpoint, setCurrentEndpoint] = useState(getApiEndpoint());
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingEndpoint, setPendingEndpoint] = useState(null);

  const handleEndpointChange = (newEndpoint) => {
    if (newEndpoint === currentEndpoint) return;
    setPendingEndpoint(newEndpoint);
    setShowConfirm(true);
  };

  const confirmChange = () => {
    if (pendingEndpoint) {
      setApiEndpoint(pendingEndpoint);
    }
  };

  const cancelChange = () => {
    setShowConfirm(false);
    setPendingEndpoint(null);
  };

  return (
    <div className="settings">
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <p className="page-subtitle">Configure your QuorumAdmin connection</p>
      </div>

      <div className="settings-section">
        <div className="section-header">
          <h2 className="section-title">API Connection</h2>
          <p className="section-desc">Choose which backend to connect to</p>
        </div>

        <div className="connection-cards">
          <button
            className={`connection-card ${currentEndpoint === 'local' ? 'active' : ''}`}
            onClick={() => handleEndpointChange('local')}
          >
            <div className="connection-icon local">
              <DatabaseIcon />
            </div>
            <div className="connection-content">
              <div className="connection-title">Local Database</div>
              <div className="connection-url">http://localhost:8001</div>
              <div className="connection-desc">
                Connect to your local Quorum backend for development and testing
              </div>
            </div>
            {currentEndpoint === 'local' && (
              <div className="connection-badge">Active</div>
            )}
          </button>

          <button
            className={`connection-card ${currentEndpoint === 'production' ? 'active' : ''}`}
            onClick={() => handleEndpointChange('production')}
          >
            <div className="connection-icon production">
              <CloudIcon />
            </div>
            <div className="connection-content">
              <div className="connection-title">Production</div>
              <div className="connection-url">dev.askquorum.io</div>
              <div className="connection-desc">
                Connect to the production AskQuorum backend (Cloudflare tunnel)
              </div>
            </div>
            {currentEndpoint === 'production' && (
              <div className="connection-badge">Active</div>
            )}
          </button>
        </div>

        <div className="current-status">
          <StatusIcon />
          <span>Currently connected to: </span>
          <code>{getApiUrl()}</code>
        </div>
      </div>

      {showConfirm && (
        <div className="modal-overlay" onClick={cancelChange}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Switch Connection</h3>
              <button className="modal-close" onClick={cancelChange}>&times;</button>
            </div>
            <div className="modal-body">
              <p>
                Switch to <strong>{pendingEndpoint === 'local' ? 'Local Database' : 'Production'}</strong>?
              </p>
              <p className="modal-note">
                The page will reload to apply this change. You may need to log in again.
              </p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={cancelChange}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={confirmChange}>
                Switch Connection
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function DatabaseIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  );
}

function CloudIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  );
}

function StatusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="status-icon">
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

export default Settings;
